var map = {
	"./1.png": "812a",
	"./2.png": "812ad",
	"./3.png": "812ad1",
	"./4.png": "812ad16",
	"./5.png": "812ad162",
	"./6.png": "812ad1622",
	"./7.png": "812ad16229",
	"./8.png": "812ad162297"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e60";